module.exports = new __parcel__URL__("ok-computer.fbc6cabc.jpg").toString();